"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
const config_1 = require("@root/config");
const defaultAWSCDKConfig_1 = require("./defaultAWSCDKConfig");
const resolvedEnvironmentVariables_1 = require("../resolvedEnvironmentVariables");
const { projectCode, stage } = resolvedEnvironmentVariables_1.resolvedEnvironmentVariables;
const TLD = config_1.parentHostedZoneName;
const shortProjectCode = projectCode.substring(0, 4);
const getInternalAccountDomain = () => `${stage}.${shortProjectCode}.${TLD}`;
exports.config = {
    aws: defaultAWSCDKConfig_1.defaultAWSCDKConfig,
    iotv: {},
    /** WIP 2024 03 adding map specific keys, currently they are imported but incorrectly used in UI */
    google: {
        // LSC=DEVELOPMENT-2025
        gcp: {
            //lsc-development-2025 lsc-apps
            clientId: '946745731000-cl4nr6qpop3paultvvgfr465qln203i5.apps.googleusercontent.com',
            apiKey: 'AIzaSyBUtFsDjgzwnTj_-0QNdJbahfbp0a0g4Fg',
        },
    },
    ventureTypeExtensions: {
        Partner: {
            partnerType: ['Partner'],
        },
    },
    internalAccountDomain: getInternalAccountDomain(),
    parentAccountDomain: config_1.parentHostedZoneName,
    entityReadings: 'S3_ATHENA_GLUE',
    incidentProducingTypes: ['StationaryEntity', 'ControlEntity', 'LevelEntity', 'RangeEntity', 'MobileEntity', 'OperatingEntity'],
    BaseData: {
        Region: {
            names: ['Africa', 'Asia Pacific', 'Europe', 'Middle East', 'North America', 'South America'],
        },
    },
    apps: {
        webUI: {
            ventureName: shortProjectCode,
            useSpecializedViews: true,
            initialRedirect: null,
            domainMap: {},
            pruneGenericEntities: false,
            pruneEntityNetworks: false,
            showProgrammeSets: true,
            groupedObjectTypes: {},
            deviceMap: {},
        },
    },
};
